import moment from "moment"

export function isOnHoliday(event, holidays) {
  if (!event || !holidays?.length) return false

  const empId = event?.employee?.id
  const slotId = event?.calenderSlotId
  const eventDate = event?.date || event?.calender?.date

  return holidays.some(h => {
    if (h.status !== true) return false
    if (h.employeeId !== empId && h.employee?.id !== empId) return false

    let slotIds = []
    try {
      slotIds = JSON.parse(h.calendarSlotIds || "[]")
    } catch {}

    if (slotIds.length > 0) {
      if (slotIds.some(sid => String(sid) === String(slotId))) return true
    }

    if (eventDate && h.fromDate && h.toDate) {
      const d = moment(eventDate).format("YYYY-MM-DD")
      const from = moment(h.fromDate).format("YYYY-MM-DD")
      const to = moment(h.toDate).format("YYYY-MM-DD")
      if (d >= from && d <= to) return true
    }

    return false
  })
}
